import React from 'react';

import { ClauseText } from '../ContractText';

const NoInspection = () => {
  return (
    <>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          This Contract is{' '}
          <span className="font-bold text-red-600">NOT contingent</span> upon{' '}
          <span className="font-bold">Buyer</span> obtaining a satisfactory home
          inspection.
        </li>
        <li>
          <span className="font-bold">Buyer</span> reserves the right to have a
          home inspection performed <ClauseText>at Buyer’s expense</ClauseText>.
        </li>
        <li>
          If <span className="font-bold">Buyer</span> elects to have a home
          inspection performed, access to the{' '}
          <span className="font-bold">Property</span> for said inspections is
          expected <ClauseText>with reasonable notice</ClauseText> to{' '}
          <span className="font-bold">Seller’s Agent</span>.
        </li>
      </ol>
    </>
  );
};

export default NoInspection;
